function Careers() {
  return (
    <div className="max-w-5xl mx-auto py-20 px-6">

      <h1 className="text-3xl font-bold mb-6">Careers at RentEase</h1>

      <p className="text-gray-600 mb-4">
        We are always looking for talented people to join our team.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Open Positions</h2>

      <ul className="list-disc pl-6 text-gray-600">
        <li>Frontend Developer</li>
        <li>Backend Developer</li>
        <li>Customer Support Executive</li>
        <li>Marketing Specialist</li>
      </ul>

      <p className="mt-6 text-gray-600">
        Send your resume to careers@rentease.com
      </p>

    </div>
  );
}

export default Careers;
